export class Application {
    appId?: string;
    profileId?: string;
    appName?: string;
    appVersionText?: string;
    appVersionValue?: string;
    executeFile?: string;
    modules?: string;
    staticCores?: string;
    mpi?: string;
    fabric?: string;
    checkLicense?: string;
    licenseCheckFlag?: boolean;
    reqLicenses?: string;
    licenseServerInfoId?: string;
    dateAdded?: Date;
    licenseFile?: string;
    licenseState?: string;
    cancelFile?: string;
    resumeFile?: string;
    suspendFile?: string;
    graphFiles?: string;
    iconFile?: string;
    userId?: string;
    depName?:string
    appVersion?: string;
    errorChips?: {value: string, tooltip: string}[];
    applicationNodeGroups?: string;
    memoryPerCPU?: string;
    templates?: string;
    defaultNodeGroups?: string;
    applicationType?: string;
    isApplicationSessionReady?: boolean;
    customActionFile?: string;
}

export class ApplicationVersion {
  public name: string;
  public value: string;

  constructor(name: string, value: string) {
    this.name= name;
    this.value = value;
  }
}

export class Mpi{
  name: string;
  value: string;

  constructor(name: string, value: string){
    this.name = name
    this.value = value
  }
}

export class LicenseCheckFlag{
  name: string;
  value: string;

  constructor(name: string, value: string){
    this.name = name
    this.value = value
  }
}

export class Fabric{
  name: string;
  value: string;

  constructor(name: string, value: string){
    this.name = name
    this.value = value
  }
}

export interface FileTypes {
  name: string;
  value: string;
}

export interface FieldType {
  name: string,
  value: string
}

export interface FieldAdded{
  id: number,
  uniqueName: string,
  fieldType: string,
  fieldName: string,
  fieldValue: string,
  isFieldRequired: boolean,
  errorMsg?: string
}

export enum ApplicationTypes {
  HPC = 0,
  HPC_VDI,
  VDI
}

export interface SessionApplicationVersion {
  applicationName: string;
  appVersionDetails: AppVersionDetails[];
}
export interface AppVersionDetails {
  appVersionText: string;
  appVersionValue: string;
}
